import { json } from 'highlight.js/lib/languages/json';
import { LayoutUtilsService } from 'src/app/core/_base/crud/utils/layout-utils.service';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';

import { ChangeDetectorRef, Component, Inject, AfterContentInit } from '@angular/core';
import { ResponseCustom } from 'src/app/models/ResponseCustom';
import { CollectorFileManageService } from './collector-file-manage.service';
import { LoaderService } from 'src/app/core/_config/loader.service';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';
import { NotificationsService } from 'angular2-notifications';
import { SimpleListConfig } from 'src/app/models/simpleListConfig';
import { NgbCalendar, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { Alert } from 'bootstrap';
import { NullTemplateVisitor } from '@angular/compiler';

@Component({
    selector: 'kt-collector-file-manage',
    templateUrl: './collector-file-manage.component.html',
    styleUrls: ['./collector-file-manage.component.scss'],
})
export class CollectorFileManageComponent implements AfterContentInit {
      
     private _date: Date = new Date();
     initialDate: Date;
     endDate: Date;
     formSearch: FormGroup;
   
     constructor(
       private FileManageService: CollectorFileManageService,
       private builder: FormBuilder,
       public loaderService: LoaderService,
       private sessionBusiness: SessionBusiness,
       private notificationsService: NotificationsService,
       private calendar: NgbCalendar,
       public formatter: NgbDateParserFormatter,
       private router: Router,
       public dialog: MatDialog,
       public layoututilsService: LayoutUtilsService,
       private cdRef: ChangeDetectorRef,
     ) {
        this.createForm();
        this._date = new Date();
        this.initialDate = new Date(this._date.getFullYear(), this._date.getMonth() -1 , this._date.getDate());
        this.endDate = new Date(this._date.getFullYear(), this._date.getMonth() , this._date.getDate());
     }
   
   
     timeSetInterval: number = 30;
     disableRefresh: boolean = false;
     resOk: boolean = false;
     receivingBatchList;
     tableDataMock: ResponseCustom;
     data;
     noData: boolean = true;
     playActive: boolean = true;
     contextSelected;
     refreshInterval;
   
     statusObj: any = [
       { description: "Todos", value: 11 },
       { description: "Processando", value: 4 },
       { description: "Aguardando Processamento", value: 0 },
       { description: "Contabilizado", value: 9 },
       { description: "Processado", value: 5 },
       { description: "Falha", value: 6 },
       { description: "Pendência", value: 10 }
     ];
     searchParams: {
       params: {
           fileName: string;
           status: number;
           initialDate: string;
           endDate: string;
           limit: any;
           skip: number;
       };
     }
     createForm() {
       this.formSearch = this.builder.group(
         {
           fileName: new FormControl(''),
           fileStatus: new FormControl(11),
           initialDate: new FormControl(''),
           endDate: new FormControl('')
         }
       )
     }
   
     configTable: SimpleListConfig = {
       useSortable: true,
       useFilter: false,
       usePagination: true,
       pageSize: [15, 20, 30],
       dateformat: 'dd/MM/yyyy',
       displayColumns: [
           {
               displayName: 'CUSTOMLIST.FILEMANAGE.COLUNS.fileName',
               field: 'fileName'
           },
           {
               displayName: 'CUSTOMLIST.FILEMANAGE.COLUNS.collectorCode',
               field: 'collectorCode'
           },
           {
               displayName: 'CUSTOMLIST.FILEMANAGE.COLUNS.date',
               field: 'date',
               type: 'date'
           },
           {
               displayName: 'CUSTOMLIST.FILEMANAGE.COLUNS.valueTotal',
               field: 'valueTotal',
               type: 'currency'
           },
           {
               displayName: 'CUSTOMLIST.FILEMANAGE.COLUNS.quantityLines',
               field: 'quantityLines'
           },
           {
               displayName: 'CUSTOMLIST.FILEMANAGE.COLUNS.processStatus',
               field: 'processStatus',
               translateKey: 'CUSTOMLIST.FILEMANAGE.VALUES'
           },
           {
               field: 'action',
               type: 'action',
           }
       ],
       lineActions: [
           {
               action: (a) => this.onSelectToDetail(a),
               label: 'Detalhes',
               color: 'primary',
               icon: 'reorder',
           },
           {
               action: (a) => this.onDelete(a),
               label: 'Deletar',
               color: 'primary',
               icon: 'delete',
           }
       ],
       page: {
           totalElements: 0,
           index: 0,
           size: 0,
       },
   };
   
     ngAfterContentInit(): void {
   
       this.contextSelected = this.sessionBusiness.Context;
   
       if (this.sessionBusiness.LegalEntityIdContext === 'NotFound') {
   
         if (this.contextSelected.LegalEntityId !== 'NotFound') {
   
           this.searchParams = {
               params: {
                   fileName: '',
                   status: this.formSearch.value.fileStatus,
                   initialDate:  this.initialDate.toJSON(),
                   endDate: this.endDate.toJSON(),
                   limit: this.configTable.pageSize[0],
                   skip: 0
               }
             }
   
           this.getListBatchs(this.searchParams);
         }
         else {
           this.notificationsService.warn("", "Não existem configurações de entidades!");
           this.resOk = true;
           this.noData = true;
         }
       } else {
          this.searchParams = {
           params: {
               fileName: '',
               status: this.formSearch.value.fileStatus,
               initialDate:  this.initialDate.toJSON(),
               endDate: this.endDate.toJSON(),
               limit: this.configTable.pageSize[0],
               skip: 0
           }
         }
   
         this.refreshComponent();
       }
     }
   
     refreshComponent() {
       this.disableRefresh = true;
   
       setTimeout(() => {
         this.disableRefresh = false;
       }, 20000);
   
       this.resOk = false;
   
       this.getListBatchs(this.searchParams);
     }
   
     ngOnDestroy() {
       clearInterval(this.refreshInterval);
     }
   
   
     getListBatchs(searchBatch: any) {
       this.loaderService.show();
   
       this.FileManageService.getReceivingBatchs(searchBatch).subscribe(res => {
   
         this.configTable.page.totalElements = res.data.totalRecords;
         this.configTable.page.index = searchBatch.params.skip / searchBatch.params.limit;
   
         var totalStatus = this.configTable.page.totalElements;
   
         if (totalStatus > this.configTable.pageSize[2]) {
           let index = this.configTable.pageSize.indexOf(totalStatus);
   
           if (index === -1) {
             this.configTable.pageSize.push(totalStatus);
           }
         }
   
         this.data = res.data.result;
   
         if (this.data.length > 0) {
           this.noData = false;
         } else {
           this.noData = true;
         }
   
         this.loaderService.hide();
         this.resOk = true;
         this.cdRef.detectChanges();
       });
     }
   
     reloadingForAction(ev) {
       this.resOk = false;
       this.searchParams.params.skip = ev.pageIndex * ev.pageSize;
       this.searchParams.params.limit = ev.pageSize;
       this.configTable.page.size = ev.pageSize;
   
       this.getListBatchs(this.searchParams);
     }
   
     validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
       const parsed = this.formatter.parse(input);
       return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
     }
   
     private onSelectToDetail(event: any): void {
   
       let queryParams = _.pick(event, ['id', 'processStatusString']);
   
       this.router.navigate([`collector-file/collector-file-audit/`, queryParams]);
    }
   
    private onDelete(event: any): void {
       if (event.processStatus != 'Succeeded' && event.processStatus !=  'Accounted') {
   
           this.layoututilsService.deleteElement('Tem certeza de que deseja deletar o arquivo?','').afterClosed().subscribe(res => {
               if ((res == true)) {
                   this.FileManageService.deleteReceivingBatchs(event.id).subscribe( del => {
                       if (del.typeResponse == 3) {
                           this.notificationsService.success("", 'Arquivos Deletados com Sucesso!');
                           this.refreshComponent();
                       } else {
                           this.notificationsService.error("", 'O Arquivo não pode ser deletado!');
                       }
                   });
               }
             });
       }
       else{
           this.notificationsService.error("", 'O Arquivo não pode ser deletado!');
       }
   }
   
     submitForm() {
       this.searchParams = {
           params: {
               fileName: this.formSearch.value.fileName,
               status: this.formSearch.value.fileStatus,
               initialDate:  this.initialDate.toJSON(),
               endDate: this.endDate.toJSON(),
               limit: this.configTable.pageSize[0],
               skip: 0
           }
         }
         this.refreshComponent();
     }
   }
   